module.exports = __webpack_public_path__ + "static/screen-web-e268933049127387cb458e4d95a17908.webp";